/**
 * Utilities for constructing triage agent related URLs
 */
import {editBlobPath} from '@github-ui/paths'

type BaseTriageAgentUrlParams = {
  repoOwner: string
  repoName: string
  defaultBranch: string
}

type EditTriageAgentUrlParams = BaseTriageAgentUrlParams & {
  configPath: string
}

type NewTriageAgentUrlParams = BaseTriageAgentUrlParams

/**
 * Constructs URL to edit existing triage-agent.md configuration file
 */
export function getTriageAgentConfigUrl({
  repoOwner,
  repoName,
  defaultBranch,
  configPath,
}: EditTriageAgentUrlParams): string {
  return editBlobPath({
    owner: repoOwner,
    repo: repoName,
    commitish: defaultBranch,
    filePath: configPath,
  })
}

/**
 * Constructs URL to create new triage-agent.md configuration file
 */
export function getNewTriageAgentConfigUrl({repoOwner, repoName, defaultBranch}: NewTriageAgentUrlParams): string {
  return `/${repoOwner}/${repoName}/new/${defaultBranch}?triage-agent=1`
}
